import React,{useEffect} from 'react';
import PropTypes from 'prop-types';
import { useField,Field } from 'formik';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  themeLabel:{
    height: "40px !important",
    borderRadius: "4px !important",
    marginRight: `${theme.spacing(2.5)}px !important`
  },
  checkBoxContrainer: {
    [theme.breakpoints.up('xs')]: {
      display: "flex",
      flexDirection: "column",
      gap: `${0.25 * 2}rem`,
    },
    [theme.breakpoints.up('md')]: {
      display: "flex",
      flexDirection: "row",
      gap: `unset`,
    }
  }
}))

function CustomCheckbox(props) {
  const classes = useStyles();
  const { label, data, ...rest } = props;
  const [meta] = useField(props);

useEffect(() => {
  if(props.selectallfields){
    let allfields = data.map(item => {
      return item.value
    })
    props.setFieldValue(props.name,allfields)
  }
  else{
    props.setFieldValue(props.name,[])
  }
  props.setFieldValue(props.name,props.values[props.name])
// eslint-disable-next-line react-hooks/exhaustive-deps
},[props.selectallfields])

  return (
    <div className={`${classes.checkBoxContrainer}`}>
        {data.map((item, index) => (
          <label key={index} className={`search_btn_check iframe_setup ${rest.classes}`} >
              <Field type="radio" name={props.name} id={`${item.value}`}  value={item.value} />
              <div className={`finishBox selectBox ${classes.themeLabel} ${meta.touched && meta.error ? 'border border-danger text-danger' : ''}`}>
                  <span>{item.label}</span>
              </div>
          </label>
        ))}
    </div>
  );
}

CustomCheckbox.defaultProps = {
  data: []
};

CustomCheckbox.propTypes = {
  data: PropTypes.array.isRequired
};

export default CustomCheckbox;
